import io from 'socket.io-client'

export {
  socketManagerInit,
  getPageConnect,
  userOutline
}
var socket
var pageName
var userInfo
function socketManagerInit(url, imPath, callback, name, info) {
  console.log('socketManagerInit ==================')
  socket = null
  imPath = "/" + imPath;
  pageName = name
  userInfo = info
  socket = io.connect(url, {
    path: imPath,
    transports: ['websocket', 'xhr-polling', 'jsonp-polling']
  })

  socket.on('connect', data => {
    callback('connected', socket)
    userOnline(userInfo)
   // getPageConnect(pageName)
  })

  socket.on('disconnect', data => {
    console.log('断开连接 ' + data)
    callback('disconnect', socket)
  })

  socket.on('error', data => {
    // console.log('error ' + data)
  })
  socket.on('pageConnectSuccess', data => {
    callback('pageConnectSuccess', data)
  })


}
function getPageConnect(pageName) {
  socket.emit('pageConnect', pageName)
}

function userOnline(userInfo) {
  socket.emit('userOnline', userInfo)
}

function userOutline(userInfo){
  socket.emit('userOutline', userInfo)
}